import React from "react";
import { Link } from "react-router-dom";
import {
  CONTACT_ADDRESS,
  CONTACT_EMAIL,
  CONTACT_PHONE,
  CONTACT_PHONE_TEL,
  SOCIAL_LINKS,
} from "../../config/contact";

import emailIcon from "../../images/icon/email-icon.svg";
import locationIcon from "../../images/icon/location-icon.svg";
import callIcon from "../../images/icon/call-icon.svg";

const logo = `${process.env.PUBLIC_URL}/webtechlogo.png`;

type FooterLink = {
  label: string;
  to: string;
  external?: boolean;
};

type FooterColumn = {
  title: string;
  links: FooterLink[];
};

const footerColumns: FooterColumn[] = [
  {
    title: "What we do",
    links: [
      { label: "Services", to: "/service" },
      { label: "Web Development", to: "/web-development" },
      { label: "Ecommerce Solutions", to: "/e-commerce-development" },
      { label: "UI/UX Design", to: "/ui-ux-design" },
      { label: "SEO Services", to: "/service" },
    ],
  },
  {
    title: "Who we are",
    links: [
      { label: "About Us", to: "/about" },
      { label: "Our Team", to: "/team" },
      { label: "Careers", to: "/career" },
      { label: "Testimonials", to: "/about" },
    ],
  },
  {
    title: "Quick links",
    links: [
      { label: "Portfolio", to: "/project" },
      { label: "Blog", to: "/blog" },
      { label: "Products", to: "/chat-bot" },
      { label: "Contact Us", to: "/contact" },
    ],
  },
  {
    title: "News & updates",
    links: [
      { label: "News", to: "/blog" },
      { label: "Events", to: "/blog" },
    ],
  },
];

const socials = [
  { icon: "fa-brands fa-facebook", name: "Facebook", url: SOCIAL_LINKS.facebook },
  { icon: "fa-brands fa-youtube", name: "YouTube", url: SOCIAL_LINKS.youtube },
  { icon: "fa-brands fa-instagram", name: "Instagram", url: SOCIAL_LINKS.instagram },
  { icon: "fa-brands fa-linkedin", name: "LinkedIn", url: SOCIAL_LINKS.linkedin },
];

const FooterLinkColumn: React.FC<{ column: FooterColumn }> = ({ column }) => (
  <div className="wt-footer__col">
    <h3 className="wt-footer__col-title">{column.title}</h3>
    <ul className="wt-footer__links list-unstyled">
      {column.links.map((link) => (
        <li key={link.label}>
          <Link to={link.to}>{link.label}</Link>
        </li>
      ))}
    </ul>
  </div>
);

const Footer: React.FC = () => {
  return (
    <footer
      className="wt-footer bg_img"
      
    >
      <div className="wt-footer__container">
        <div className="wt-footer__main">
          <div className="wt-footer__brand">
            <Link to="/" className="wt-footer__logo" aria-label="WebTech home">
              <img src={logo} alt="WebTech" />
            </Link>
            <p className="wt-footer__tagline">
              We build modern, scalable and performance-driven websites that help
              businesses grow online.
            </p>
            <div className="wt-footer__socials">
              {socials.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.name}
                  className="wt-footer__social-link"
                >
                  <i className={social.icon} aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>

          {footerColumns.map((column) => (
            <FooterLinkColumn key={column.title} column={column} />
          ))}
        </div>

        <div className="wt-footer__contact">
          <div className="wt-footer__contact-item">
            <img src={locationIcon} alt="" aria-hidden="true" />
            <span>{CONTACT_ADDRESS}</span>
          </div>
          <div className="wt-footer__contact-item">
            <img src={emailIcon} alt="" aria-hidden="true" />
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
          </div>
          <div className="wt-footer__contact-item">
            <img src={callIcon} alt="" aria-hidden="true" />
            <a href={`tel:${CONTACT_PHONE_TEL}`}>{CONTACT_PHONE}</a>
          </div>
        </div>

        <div className="wt-footer__bottom">
          <p className="wt-footer__copyright">
            &copy; 2025 Webtech. All rights reserved.
          </p>
          <div className="wt-footer__legal">
            <Link to="/contact">Privacy Policy</Link>
            <span className="wt-footer__legal-divider" aria-hidden="true">
              |
            </span>
            <Link to="/contact">Terms &amp; Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
